// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1oWeS","name":"Header_name__1e-1y","birthday":"Header_birthday__OrAUi","skeleton":"Header_skeleton__79VGU"};